import api from './api';

export const getPdfExportStatus = async () => {
  const response = await api.get('/cookbook-pdf/status');
  return response.data;
};

export const downloadCookbookPdf = async () => {
  const response = await api.get('/cookbook-pdf/download', { responseType: 'blob' });
  return response.data; // a Blob
};
